<template>
  <v-img
      src="@/assets/highlights.png"
      width="250"
      class="image fixed px-3 pt-3 pb-8 mb-5"
      height="510"
  >
    <div ref="sponsorPreviewContainer" v-resize="getSponsorPreviewWidth">
      <v-card
          :class="[{ 'rounded-corners': !isWebPage }, 'mb-3 overflow-y-auto  overflow-x-hidden']"
          :height="height"
          :max-height="maxHeight"
      >

        <v-col class="pa-0">
          <v-row class="pt-4 pb-2 px-4">
            <v-col cols="2" class="pa-0">
              <v-icon class="py-0">mdi-chevron-left</v-icon>
            </v-col>

            <v-col cols="8" class="pa-0 ma-0 headerClass" align-self="center">
              <v-card-subtitle align="center" class="pa-0" > <div class="headerClass">{{ sponsor.name }}</div> </v-card-subtitle>
            </v-col>

            <v-col cols="2"/>


          </v-row>
          <v-divider class="py-0"/>

          <v-row align="center" justify="center">
            <v-col cols="7" align-self="center">
              <v-img :src="sponsor.logoURL" max-width="100%" height="auto" class="rounded-lg"></v-img>
            </v-col>
            <v-col cols="12" align-self="center" class="justify-center align-center pa-0">
              <div class="text-center">
                <v-card-text class="py-0 px-6" align-self="center">

                  {{ sponsor.name }}
                </v-card-text>
              </div>
            </v-col>
          </v-row>
          <v-divider class="thickDivider my-2"/>
          <v-row>
            <v-col class="pa-0 ma-0">
              <v-card-text class="py-1 px-6">
                Info
              </v-card-text>
              <v-divider class="pa-0 ma-0 blackDivider" v-if="tab==0"/>
            </v-col>
            <v-col class="pa-0 ma-0">
              <v-card-text class="py-1">
                Representatives
              </v-card-text>
              <v-divider class="pa-0 ma-0 blackDivider" v-if="tab==1"/>
            </v-col>
            <v-spacer/>
          </v-row>
          <v-divider/>
          <template v-if="tab == 0">
            <v-col cols="12">
              <v-card-subtitle class="pa-0 ma-0 text--black font-weight-bold">
                Bio
              </v-card-subtitle>
              <v-card-text class="pa-0 ma-0 text--black font10 text-sm-caption" style="white-space: pre-line">
                {{ sponsor.bio }}
              </v-card-text>
              <v-divider class="my-2"/>
              <v-card-subtitle class="pa-0 ma-0 text--black font-weight-bold">
                Contact
              </v-card-subtitle>
              <v-list-item class="py-2 ma-0" v-if="sponsor.generalPhone!=''">
                  <v-icon class="pr-4 py-0" size="20">mdi-phone-outline</v-icon>
                <v-list-item-content class="pa-0 ma-0">
                  <v-list-item-title class="pa-0 ma-0 font10">{{ sponsor.generalPhone }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="py-2 ma-0" v-if="sponsor.generalEmail!=''">
                <v-icon class="pr-4" size="20">mdi-email-outline</v-icon>
                <v-list-item-content class="py-0">
                  <v-list-item-title class="font10 pa-0">{{ sponsor.generalEmail }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="py-2 ma-0 pa-0" v-if="sponsor.website!=''">
                <v-img src="@/assets/website-icon.svg" height="19" width="18" contain class="pa-0" max-width="18" />
                <v-list-item-content class="pl-4 py-0">
                  <v-list-item-title class="font10">{{ sponsor.website }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="my-2"/>
              <v-card-subtitle class="pa-0 ma-0 text--black font-weight-bold">
                Socials
              </v-card-subtitle>
              <v-row align="center" justify="start" class="px-2">
                <div v-for="social in socials">
                  <div  class="pa-2 mx-1 rounded-corners socialIconBg" v-if="social.url!=''">
                    <v-img :src="require(`@/assets/${social.icon}`)" height="10" width="10" contain class="ma-0 pa-0" max-width="10" />
                  </div>
                </div>

              </v-row>
            </v-col>
          </template>
        </v-col>
      </v-card>
    </div>
  </v-img>
</template>

<script>
import Preview from "@/components/LinkInBio/Preview.vue";
import Sponsor from "@/models/Sponsor";

export default {
  name: "SponsorPreview",
  components: {Preview},
  props: {
    sponsor: {
      type: Sponsor,
      required: true,
    },
    height: {type: String},
    maxHeight: {type: String},
    isWebPage: {type: Boolean, default: false},
    tab: {type: Number, default: 0},

  },
  computed: {
    socials() {
      return  [
        {
          icon: 'facebook-icon.svg',
          url: this.sponsor.facebook,
        },
        {
          icon: 'instagram-icon.svg',
          url: this.sponsor.instagram,
        },
        {
          icon: 'linkedin-icon.svg',
          url: this.sponsor.linkedin,
        },
        {
          icon: 'twitter-icon.svg',
          url: this.sponsor.twitter,
        },
        {
          icon: 'youtube-icon.svg',
          url: this.sponsor.youtube,
        },
        {
          icon: 'podcast-icon.svg',
          url: this.sponsor.podcast,
        }
      ]
    }
  },
  data(){
    return {

  }
  },
  methods: {

    getSponsorPreviewWidth() {
      if (this.$refs.sponsorPreviewContainer != null) this.x = this.$refs.sponsorPreviewContainer.clientWidth;
    },
  },
  created() {
    console.log(this.sponsor.facebook);
  },
}
</script>

<style scoped>
.rounded-corners {
  border-radius: 20px !important;
}

.blackDivider {
  border-width: 1px !important;
  border-color: #000000 !important;
}

.thickDivider {
  border-width: 2px !important;
  color: #F6F7FC !important;
  height: 100%;
}

.socialIconBg {
  background: #0024340A
}

.font12 {
  font-size: 12px !important;
}

.font10 {
  font-size: 10px !important;
}



.headerClass{
  white-space: nowrap ;
  word-break: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>